<template>
    <div>
        <b-row>
            <b-col cols="12" md="4">
                <b-form-group :label="$t('course_code')" label-for="mapping-course-code">
                    <b-form-input id="mapping-course-code" v-model.trim="filter.course_code" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group :label="$t('program')" label-for="mapping-program-code">
                    <program-selectbox id="mapping-program-code" v-model="filter.program_code" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group :label="$t('report_type')">
                    <multi-selectbox
                        :allow-empty="false" :multiple="false"
                        :options="responseTypeOptions" v-model="responseType"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-button variant="primary" :disabled="processing" @click="getReport">
                    {{ $t('get_report').toUpper() }}
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import MultiSelectbox from '@/components/interactive-fields/MultiSelectbox'
import LecturerReportService from '@/services/LecturerReportService'
import qs from 'qs'

export default {
    name: 'CourseToProgramMappingReport',
    components: {MultiSelectbox},
    data() {
        return {
            filter: {
                course_code: '',
                program_code: ''
            },
            processing: false,
            responseType: 'excel',
            responseTypeOptions: [
                {value: 'excel', text: this.$t('excel')},
            ]
        }
    },
    methods: {
        async getReport() {
            if (this.processing) return

            const responseType = this.responseType
            const config = {
                params: {
                    filter: {
                        course_code: this.filter.course_code || undefined,
                        program_code: this.filter.program_code || undefined
                    },
                    response_type: responseType
                },
                paramsSerializer: params => qs.stringify(params)
            }
            if (responseType !== 'page') {
                config.responseType = 'arraybuffer'
            }

            this.processing = true
            try {
                const response = await LecturerReportService.getCourseToProgramMappingReport(config)
                this._downloadFile(response, 'course_to_program_mapping_report.xlsx')
            } catch (error) {
                this.showErrors(error)
            } finally {
                this.processing = false
            }
        }
    }
}
</script>
